<template>
    <div>
        <el-table
            id="FutureDeliveryRequestTable"
            style="width: 100%"
            max-height="700"
            empty-text="You have no future delivery requests."
            :data="futureDeliveries"
            @row-click="$emit('rowClicked', $event)"
        >
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :sortable="column.sortable"
                :formatter="column.formatter"
                :sort-method="column.sortMethod"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    {{ scope.column.label }}
                </template>
                <template slot-scope="props">
                    <template v-if="props.column.property === 'status'">
                        <div :class="getStyleForStatus(props.row.status)">
                            {{ props.row.status }}
                        </div>
                    </template>
                    <template v-else-if="props.column.formatter">
                        {{ props.column.formatter(props.row) }}
                    </template>
                    <template v-else>
                        {{ getProp(props.row, props.column.property) }}
                    </template>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { DatePicker } from "element-ui";

import moment from "moment-timezone";
import _ from "lodash";

export default {
    name: "FutureDeliveryRequestsTable",
    components: {
        [DatePicker.name]: DatePicker,
    },
    props: {
        futureDeliveries: {
            type: Array,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "ID",
                    sortable: true,
                    width: 100,
                },
                {
                    prop: "customer_name",
                    label: "Customer",
                    minWidth: 250,
                },
                {
                    prop: "status",
                    label: "Status",
                    sortable: true,
                    minWidth: 110,
                    width: 150,
                },
                {
                    prop: "designer_name",
                    label: "Designer",
                    width: 150,
                },
                {
                    prop: "location",
                    label: "Location",
                    width: 200,
                },
                {
                    prop: "delivery_city",
                    label: "City",
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "delivery_date",
                    label: "Time",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.delivery_date) - new Date(a.delivery_date),
                    formatter: (row) => this.deliveryDateWithTime(row),
                    width: 250,
                },
                {
                    prop: "created_at",
                    label: "Submitted",
                    formatter: (row) => `${this.formatDate(row.created_at)}`,
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.created_at) - new Date(a.created_at),
                    width: 200,
                },
                {
                    prop: "updated_at",
                    label: "Updated",
                    formatter: (row) =>
                        `${this.formatUpdated(row.updated_at, row.created_at)}`,
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.updated_at) - new Date(a.updated_at),
                    width: 200,
                },
            ];
            // eslint-disable-next-line max-len
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
        getProp(object, property) {
            return _.get(object, property);
        },
        getStyleForStatus(status) {
            return [status.toLowerCase(), "statusLabel"];
        },
        formatUpdated(updated, created) {
            if (updated && updated !== created) {
                return moment(updated).format("MM/DD/YYYY - h:mm A ");
            }
            return "--";
        },
        deliveryDateWithTime(item) {
            let time = item.delivery_window;
            if (time === "Morning") time = "9AM - 11AM";
            if (time === "Midday") time = "11AM - 1PM";
            if (time === "Afternoon") time = "1PM - 3PM";
            if (time === "Any") time = "9AM - 3PM";
            return `${this.formatDate(item.delivery_date)} ${time}`;
        },
    },
};
</script>
